import React, { useState } from 'react';
import {
    TBuyerAdditionalDetails,
    THomeserveOfferDetails,
    TOfferAdditionalCustomer,
    TOfferDetailsProviderProperties,
} from './offer-details.types';
import { OfferDetailsContext } from './offer-details.context';

export function OfferDetailsProvider({
    children,
}: TOfferDetailsProviderProperties) {
    const [propertyId, setPropertyId] = useState<number>(0);
    const [offerAmount, setOfferAmount] = useState<string>('');
    const [comment, setComment] = useState<string>('');
    const [buyers, setBuyers] = useState<TOfferAdditionalCustomer[]>([]);
    const [
        buyerAdditionalDetailsInputModel,
        setBuyerAdditionalDetailsInputModel,
    ] = useState<TBuyerAdditionalDetails>({
        propertyId: 0,
        propertyToSell: false,
        mortgageRequired: false,
        mortgageAgreementStatus: 'NotYetArranged',
        cashSource: 'Savings',
        moveTimeframe: new Date(),
        timeOnMarket: new Date(),
        saleProgression: 'Pending',
        isInChain: undefined,
        chainTimeFrameAgreed: undefined,
        isPbConnected: false,
        consentedForMAB: undefined,
        media: 'WebSite',
    });
    const [homeserveOfferDetails, setHomeserveOfferDetails] =
        useState<THomeserveOfferDetails>({
            offerId: 0,
            byEmail: false,
            byPhone: false,
            byPost: false,
            bySms: false,
            proceedWithoutExtra: false,
            propertyIsPermanentResidence: false,
            propertyIsRetailCommercialOrBusiness: false,
        });

    return (
        <OfferDetailsContext.Provider
            value={{
                buyerAdditionalDetailsInputModel,
                buyers,
                comment,
                homeserveOfferDetails,
                offerAmount,
                propertyId,
                setBuyerAdditionalDetailsInputModel,
                setBuyers,
                setComment,
                setHomeserveOfferDetails,
                setOfferAmount,
                setPropertyId,
            }}
        >
            {children}
        </OfferDetailsContext.Provider>
    );
}
